import { AccountDetailsAccordion } from '@client/components/ltc-financial-planning/AccountDetailsAccordion';
import { AddAssetSection } from '@client/components/ltc-financial-planning/AddAssetSection';
import { AppState } from '@client/model/store';
import { useSelector } from 'react-redux';

import { StepContentProps } from '../types';

export function AccountDetailsStep({ navigation }: StepContentProps) {
  // Check if all accounts have been completed
  const { selectedAssets, accountDetails } = useSelector(
    (state: { ltcFinancialPlanning: AppState['ltcFinancialPlanning'] }) =>
      state.ltcFinancialPlanning,
  );
  const allAccountsComplete = selectedAssets.every(asset => {
    const detail = accountDetails[asset];
    return detail && detail.isComplete === true;
  });

  return (
    <div className="py-8">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900 md:text-3xl">
          Let's get some details on these accounts
        </h1>
        <p className="mx-auto mt-3 max-w-2xl text-base text-gray-700">
          Click on each account to add the financial details. This helps us accurately project your
          long-term care coverage capacity.
        </p>
      </div>

      <AccountDetailsAccordion className="mx-auto mt-8 max-w-3xl" />

      <AddAssetSection
        skipDetails
        className="mx-auto mt-4 max-w-3xl"
      />

      {!allAccountsComplete && selectedAssets.length > 0 && (
        <p className="mt-4 text-center text-sm text-gray-500">
          Please complete all account details to continue
        </p>
      )}
    </div>
  );
}
